import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useBrand } from '@/shared/hooks/useBrand/useBrand';

/**
 * The browser tab's title, from the brand (P28).
 *
 * `index.html` ships the neutral product title for the moment before the first
 * request (U16); this replaces it with `<brand> · <title>` once `/app-settings`
 * answers, and keeps it current across a locale switch — `t` changes identity
 * with the language, and the brand name is re-read per locale.
 */
export function useDocumentTitle(): void {
  const { t } = useTranslation('common');
  const { name } = useBrand();

  useEffect(() => {
    const product = t('shell.title');
    document.title = name === '' ? product : `${name} · ${product}`;
  }, [name, t]);
}
